import styled, { css } from 'styled-components';

export const ErrorMessageWrapper = styled.div`
    display: flex;
    align-items: center;

    svg {
        min-width: 22px;
    }
`;

export const ErrorText = styled.p(
    ({ theme: { colors, fontSizes, fontFamily } }) => css`
        color: ${colors.error};
        font-family: ${fontFamily.secondary};
        font-size: ${fontSizes.f12};
        font-weight: 500;
        line-height: 1;
        padding-left: 4px;
        width: 100%;
    `,
);
